import styled from "styled-components";
import themes from "@/styles/themes";
const Footer = styled.div`
  margin: 10px 0 ;
  text-align: center;

  p {
    font-weight: 700;
    color:${themes.greyNormal};
    margin: 15px 0;
    line-height: 1.34;
    font-size: 13px;
  }
`

export default Footer